import { useTranslation } from "react-i18next";

const News1 = () => {
    const { t } = useTranslation();

    return <p>{t("Dashboard##news##body##1")}</p>;
};

export { News1 };
